import "../css/shopRefer.css";

function ShopRefer() {
    return (
        <a className="shop-refer" href="https://shop.larrybirdle.com/">
            Larry Birdle
            <br />
            Merch Store
        </a>
    );
}

export default ShopRefer;
